import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=58c7332a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c7332a')) {
      api.createRecord('58c7332a', component.options)
    } else {
      api.reload('58c7332a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=58c7332a&", function () {
      api.rerender('58c7332a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kspV1OJJZAO0/JS/offershelp.vue"
export default component.exports